import { NgModule } from '@angular/core';
import { SharedModule } from '../shared/shared.module';
import { UserRoutingModule } from './user-routing.module';
import { HomeuserComponent } from '../homeuser/homeuser.component';
import { CaissierComponent } from '../caissier/caissier.component';
import { GestionnaireComponent } from '../admin/gestionnaire/gestionnaire.component';
import { EspaceClientComponent } from '../espace-client/espace-client.component';
import { BspaceComponent } from '../bspace/bspace.component';
import { BussnessTransactionComponent } from '../bussness-transaction/bussness-transaction.component';
import { ProfileComponent } from '../profile/profile.component';
import { TransfertComponent } from '../transfert/transfert.component';
import { StatisticComponent } from '../statistic/statistic.component';
import { MesAchatsComponent } from '../mes-achats/mes-achats.component';
import { MesDepotsComponent } from '../mes-depots/mes-depots.component';
import { MesRetraitsComponent } from '../mes-retraits/mes-retraits.component';
import { MesTransfertComponent } from '../mes-transfert/mes-transfert.component';
import { MesMensualiteComponent } from '../mes-mensualite/mes-mensualite.component';
import { AffairesAchatsComponent } from '../affaires-achats/affaires-achats.component';
import { AffairesDepotsComponent } from '../affaires-depots/affaires-depots.component';
import { AffairesMensualitesComponent } from '../affaires-mensualites/affaires-mensualites.component';
import { AffairesRetraitsComponent } from '../affaires-retraits/affaires-retraits.component';
import { AffairesFacturationsComponent } from '../affaires-facturations/affaires-facturations.component';
import { AffaireTransfertComponent } from '../affaire-transfert/affaire-transfert.component';
import { IdentificationComponent } from '../identification/identification.component';

@NgModule({
  declarations: [
    HomeuserComponent,
    CaissierComponent,
    GestionnaireComponent,
    EspaceClientComponent,
    BspaceComponent,
    BussnessTransactionComponent,
    ProfileComponent,
    TransfertComponent,
    StatisticComponent,
    MesAchatsComponent,
    MesDepotsComponent,
    MesRetraitsComponent,
    MesTransfertComponent,
    MesMensualiteComponent,
    AffairesAchatsComponent,
    AffairesDepotsComponent,
    AffairesMensualitesComponent,
    AffairesRetraitsComponent,
    AffairesFacturationsComponent,
    AffaireTransfertComponent,
    IdentificationComponent
  ],
  imports: [SharedModule, UserRoutingModule]
})
export class UserModule { }
